<template>
  <BaseScreen v-bind="screen">
    <BaseAlert
      v-if="isErrorVisible"
      v-bind="error"
      slot="middle"
    />
    <BaseAlert
      v-if="isThanksVisible"
      v-bind="thanks"
      slot="middle"
    />
  </BaseScreen>
</template>

<script>
import { v4 as uuidv4 } from 'uuid';
import CONSTANTS from '@/helpers/constants';
import screenMixin from '@/mixins/screen';

export default {
  name: 'TemperatureScreen',
  mixins: [screenMixin],
  data() {
    return {
      isMeasuringDone: false,
      isTemperatureNormal: false,
    };
  },
  staticData: () => ({
    redirectTimeout: null,
  }),
  computed: {
    pendingText() {
      return this.$t('pending.hardware');
    },
    screenCase() {
      if (this.isMeasuringDone) {
        return this.isTemperatureNormal
          ? CONSTANTS.STEP_GOOD_TEMPERATURE
          : CONSTANTS.STEP_BAD_TEMPERATURE;
      }
      if (this.isErrorVisible) {
        return CONSTANTS.STEP_HARDWARE_ERROR;
      }
      return null;
    },
    thanks() {
      return {
        icon: {
          name: 'success',
          theme: 'primary',
          size: 'l',
        },
        title: {
          text: this.$t('texts.temperatureNormal'),
          size: 'l',
        },
        description: {
          text: this.$t('texts.measuringAlreadyDone'),
          size: 'l',
        },
        actions: [
          {
            text: this.$t('actions.home'),
            action: this.goToHomeScreen,
            view: 'outlined',
          },
        ],
      };
    },
    error() {
      return {
        icon: {
          name: 'important',
          theme: 'secondary',
          size: 'l',
        },
        title: {
          text: this.$t('titles.badHardware'),
          size: 'l',
        },
        description: {
          text: this.$t('texts.temperatureMeasureNotPossible'),
          size: 'l',
        },
        actions: [
          {
            text: this.$t('actions.home'),
            action: this.goToHomeScreen,
            view: 'outlined',
          },
        ],
      };
    },
    storageKey() {
      return `measuring_face_${this.$route.query.id}`;
    },
  },
  created() {
    this.checkLastMeasuring();
  },
  beforeDestroy() {
    this.clearRedirectTimeout();
  },
  methods: {
    checkLastMeasuring() {
      const storageValue = localStorage.getItem(this.storageKey);
      const timestamp = Date.now() - Number(storageValue || 0);
      const dayInMs = 1 * 24 * 60 * 60 * 1000; // один день;
      return timestamp < dayInMs
        ? this.skipMeasuring()
        : this.startMeasuring();
    },
    setMeasuringSettings() {
      localStorage.setItem('tempSettings', JSON.stringify({
        showLangSwitcher: false,
        language: 'ru_RU',
        badTemp: CONSTANTS.BAD_TEMPERATURE,
      }));
    },
    startMeasuring() {
      const unsubscribe = this.$robot.systemService.onApplicationFinished(({ name }) => {
        if (name === 'org.promobot.termo') {
          const result = JSON.parse(localStorage.getItem('tempCase') || '{}');
          if (result.finished) {
            this.onMeasuringFinish(Number(result.temp));
          } else if (result.hardware_error) {
            this.showError();
          } else {
            this.stopInteraction();
          }
          unsubscribe();
        }
      });
      this.setMeasuringSettings();
      this.$robot.dialogService.sayReplicByData({
        id: { uuid: uuidv4() },
        actions: 'app:org.promobot.termo',
        text: '"',
        type: 21,
      }, true);
    },
    onMeasuringFinish(value) {
      this.isMeasuringDone = true;
      this.isTemperatureNormal = value < CONSTANTS.BAD_TEMPERATURE;
      if (this.isTemperatureNormal) {
        localStorage.setItem(this.storageKey, Date.now());
        this.setRedirectTimeout(250);
      } else {
        this.stopInteraction();
      }
    },
    skipMeasuring() {
      this.isTemperatureNormal = true;
      this.showThanks();
      this.setRedirectTimeout(4000);
    },
    setRedirectTimeout(timeout) {
      this.redirectTimeout = window.setTimeout(this.goToHomeScreen, timeout);
    },
    clearRedirectTimeout() {
      window.clearTimeout(this.redirectTimeout);
    },
  },
};
</script>
